import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-fiel-title',
  templateUrl: './fiel-title.component.html',
  styleUrls: ['./fiel-title.component.scss']
})
export class FielTitleComponent implements OnInit {

  @Input() label = '';
  @Input() required: any;
  @Input() enabled = true;

  constructor() { }

  ngOnInit(): void {
  }

}
